import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import { getLocationIndex, fetchLocationIndex, getLocation, fetchLocation } from '../../../store/client'

import InputField, { validateInput } from '../../../shared/ui/InputField'

import { withStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

const styles = theme => ({
  root: {
  },
})

const VenueForm = ({ theme, classes, formData, onFormDataChange, errorFields={}, ...props }) => {

  const { fetchProvinces, fetchCities, provinces, allCities } = props  
  const cities = (formData && formData.state && allCities[formData.state]) || {}
  
  useEffect(() => {
    fetchProvinces()
  }, [])
  
  useEffect(() => {
    if (formData.state)
      fetchCities(formData.state)
  }, [formData.state])
  
  const venueTypeOptions = [
    { text: 'In House', value: "1" },
    { text: 'Arranged by PasarTrainer', value: "0"}
  ]
  const facilityStarOptions = [
    { text: '3 Star Facility', value: "3" },
    { text: '4 Star Facility', value: "4" },
    { text: '5 Star Facility', value: "5"}
  ]
      
  return (
    <Box display='flex' flexDirection='column' alignItems='stretched'>    
      <InputField
        fieldName='venue_in_house'
        type='option'
        options={venueTypeOptions}
        value={formData.in_house ? "1" : "0"}
        error={errorFields.in_house}
        onChange={(value) => onFormDataChange('in_house')(value == "1" ? true : false)}
        gutterBottom
        />
      <InputField
        fieldName='venue_state'
        type='option'
        label='Province'
        options={provinces.lastFetched ? provinces.data.records.map(l => l.name) : []}
        value={formData.state}
        error={errorFields.state}
        onChange={onFormDataChange('state')}
        style={{marginTop:8}}
        gutterBottom
      />
      <InputField
        fieldName='venue_line4'
        type='option'
        label='City'
        options={cities.lastFetched ? cities.data.map(l => l.name) : []}
        value={formData.line4}
        style={{marginTop:8}}
        error={errorFields.line4}
        onChange={onFormDataChange('line4')}
        gutterBottom
      />
      
      { !formData.in_house &&
        <InputField
          fieldName='venue_facility_star'
          type='option'
          label='Facility Star'
          options={facilityStarOptions}
          value={formData.facility_star}
          error={errorFields.facility_star}
          onChange={onFormDataChange('facility_star')}
          gutterBottom
        />
      }
    </Box>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    provinces: getLocationIndex(state, 'province'),
    allCities: getLocation(state)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchProvinces: () => {
      dispatch(fetchLocationIndex('province'))
    },
    fetchCities: (province) => {
      dispatch(fetchLocation(province))
    },
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(VenueForm)
)
